// JS that we expect to change very infrequently:
// - external libraries
// - deprecated Academia.edu utility & parent-class code
// - very basic, static infrastructure (`Aedu` namespace, $image_url)
//
// Does what you're adding belong in application.js, or a page-specific file?
//
// Put any new libraries as close to the top as you can, while remaining below
// any dependencies (e.g. jquery).
import 'sprocket-compat?this&pre&post!requirejs/require.js';
import 'javascripts/jquery/index_FORMERLY_SPROCKETS.wjs.js';
import 'javascripts/jquery.payment/index.js';
import 'javascripts/former-gems/rails-assets-kevinwuhoo--trunk8-1.3.5/app/assets/javascripts/trunk8.js';
import 'javascripts/former-gems/rails-assets-kevinwuhoo--trunk8-1.3.5/app/assets/javascripts/trunk8/trunk8.js';
import 'underscore/underscore.js';
import lodash from 'lodash';
lodash.noConflict();
import 'bootstrap/dist/js/bootstrap.js';
import '!!sprocket-compat?this&module!backbone/backbone.js';
import 'sprocket-compat?this!javascripts/base/_namespace.coffee';
import 'sprocket-compat?this!javascripts/backbone/deprecated_academia_base/model.coffee';
import 'sprocket-compat?this!javascripts/backbone/deprecated_academia_base/view.coffee';
import 'javascripts/jquery_plugins/jquery.autosize-1.18.9.js';
import 'javascripts/jquery_plugins/jquery.cookie.js';
import 'javascripts/jquery_plugins/jquery.form.helpers.js';
import 'sprocket-compat?this!javascripts/jquery_plugins/jquery.more_link.coffee';
import '!!javascripts/jquery_plugins/jquery.observe-2.0.1.js';
import 'javascripts/jquery_plugins/jquery.timeago-0.10.0.js';
import 'javascripts/jquery_plugins/misc_extensions.js';
import 'javascripts/deprecated_object_hierarchy/index.js';
import 'javascripts/deprecated_widget_dsl.js';
import 'javascripts/scribd_api/index.js';
import 'javascripts/core_pre_webpack/index.js';
import 'javascripts/pug/jst_lookup_compat.ts';
